const apiRoutes = {
  users: {
    admin: {
      expenses: "/expenses",
      bulkImport: "/bulkImport",
      projects: {
        "": "",
        milestone: "/milestone",
      },
      project: "/project",
      transaction: "/transaction",
      message: "/message",
      users: {
        "": "",
        updateStatus: "/updateStatus",
        edit: "/edit",
      },
      invoices: "/invoices",
      companyInfo: "/companyInfo",
      initializeDelete: "/initializeDelete",
      projectInvoices: "/projectInvoices",
      self: {
        "": "",
        updatePassword: "/updatePassword",
      },
      notification: "/notification",
    },

    superadmin: {
      admin: {
        "": "",
        list: "/list",
        updateStatus: "/updateStatus",
        assignNotification: "/assignNotification",
      },
      notification: "/notification",
    },

    user: {
      dashboard: "/dashboard",
      expenses: "/expenses",
      transaction: "/transaction",
      message: "/message",
      milestone: "/milestone",
      projects: {
        "": "",
        milestone: "/milestone",
      },
      project: "/project",
      self: {
        "": "",
        updatePassword: "/updatePassword",
      },
    },
  },
};

export const getRoute = (
  route,
  routeKey,
  subRouteKey,
  includeRoute,
  includeSubRoute = true,
  subRoute,
) => {
  const baseRoute = apiRoutes?.[route]?.[routeKey]?.[subRouteKey];
  if (!baseRoute) {
    console.error("Invalid route", { route, routeKey, subRouteKey, subRoute });
    return "";
  }

  // Handle object-type sub-routes correctly
  if (typeof baseRoute === "object") {
    if (subRoute && baseRoute[subRoute]) {
      return includeRoute
        ? `/${route}/${routeKey}/${subRouteKey}${baseRoute[subRoute]}`
        : `${routeKey}/${subRouteKey}${baseRoute[subRoute]}`;
    }

    // Fix: If no subRoute is provided but baseRoute is an object, return an empty string
    return includeRoute
      ? `/${route}/${routeKey}/${subRouteKey}`
      : `${routeKey}/${subRouteKey}`;
  }

  return includeRoute
    ? `/${route}/${routeKey}${baseRoute}` // Fix: Removed extra `subRouteKey` for non-object cases
    : `${routeKey}${baseRoute}`;
};
